module.exports = __webpack_public_path__ + "img/down-arrow.9a0aee31.svg";